import { StyledPublishStatus } from "./styled-components";

export interface NoLinkIndicatorProps {
    className?: string;
    icon: any;
    label: string;
}

/**
 * status indicator for cases where the indicator should act as a plain text
 */
const NoLinkIndicator = (props: NoLinkIndicatorProps) => {
    const { className, icon, label } = props;

    return (
        <StyledPublishStatus className={className}>
            {icon}
            {label}
        </StyledPublishStatus>
    );
};

export default NoLinkIndicator;
